var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    id: "logo-open",
    viewBox: "0 0 36.77 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.87895 28.133V26.3497V16.5594L5.33028 15.6495L0 12.5195V18.7795V24.1296V30.3532V32.1729L1.54866 33.0828L6.87895 36.1764L11.4889 38.8696L16.8552 41.9996V35.7396V33.9563L8.42761 29.0429L6.87895 28.133Z",
    fill: "#08A2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3083 13.8302L29.857 12.9203L35.2233 9.82669L29.857 6.69671L25.283 4.00347L19.9167 0.909879L18.368 0L16.8554 0.909879L11.4891 4.00347L6.87911 6.69671L1.54883 9.82669L6.87911 12.9203L8.42778 13.8302L16.8554 8.95321L18.368 8.04333L19.9167 8.95321L28.3083 13.8302Z",
    fill: "#1C2743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4059 15.6495L29.8573 16.5594V26.3497V28.133L28.3086 29.0429L19.917 33.9563V35.7396V41.9996L25.2833 38.8696L29.8573 36.1764L35.2236 33.0828L36.7722 32.1729V30.3532V24.1296V18.7795V12.5195L31.4059 15.6495Z",
    fill: "#C2C923"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOeSmall);
export default __webpack_public_path__ + "static/media/logo-oe-small.375970af.svg";
export { ForwardRef as ReactComponent };